
import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define translations
const translations: Record<string, Record<string, string>> = {
  en: {
    // Navigation
    'Home': 'Home',
    'Portfolio': 'Portfolio',
    'Services': 'Services',
    'Advantages': 'Advantages',
    'About': 'About',
    'Contact': 'Contact',
	'Clients': 'Clients',
    
    // Portfolio tabs
    'Videos': 'Videos',
    'Photos': 'Photos',
    'Websites': 'Websites',
	
	 // Portfolio title
    'Professional video production services for corporate, promotional, and creative projects' : 'Professional video production services for corporate, promotional, and creative projects',
	'High-quality photography capturing moments, landscapes, and commercial subjects with creativity' : 'High-quality photography capturing moments, landscapes, and commercial subjects with creativity',
	'Custom website design and development for businesses of all sizes and industries' : 'Custom website design and development for businesses of all sizes and industries',
    
    // Section titles
    'Visual Stories': 'Visual Stories',
    'Capturing life\'s most beautiful moments through professional videography': 'Capturing life\'s most beautiful moments through professional videography',
    'Explore My Work': 'Explore My Work',
    'About Me': 'About Me',
    
    // Hero Slider
    'Stunning Photography': 'Stunning Photography',
    'Professional photography that captures the essence of your brand': 'Professional photography that captures the essence of your brand',
    'Modern Websites': 'Modern Websites',
    'Responsive websites that work perfectly on all devices': 'Responsive websites that work perfectly on all devices',
	
	    
    // Services section
    'How I Can Help Your Business Grow': 'How I Can Help Your Business Grow',
    'Professional Video Production': 'Professional Video Production',
    'Videos can increase engagement by up to 80% on your website and social media platforms. With professional videography, your business can showcase products, services, and brand values in a compelling format that connects emotionally with your audience.': 'Videos can increase engagement by up to 80% on your website and social media platforms. With professional videography, your business can showcase products, services, and brand values in a compelling format that connects emotionally with your audience.',
    'High-Quality Photography': 'High-Quality Photography',
    'Professional photography can elevate your brand image and make you stand out from competitors. High-quality visuals are essential for marketing materials, websites, and social media, helping you communicate your brand message effectively and attract more customers.': 'Professional photography can elevate your brand image and make you stand out from competitors. High-quality visuals are essential for marketing materials, websites, and social media, helping you communicate your brand message effectively and attract more customers.',
    'Custom Website Development': 'Custom Website Development',
    'A well-designed website serves as your 24/7 digital storefront. By creating responsive, user-friendly websites tailored to your business needs, I help you establish a professional online presence that converts visitors into customers and provides valuable analytics to grow your business.': 'A well-designed website serves as your 24/7 digital storefront. By creating responsive, user-friendly websites tailored to your business needs, I help you establish a professional online presence that converts visitors into customers and provides valuable analytics to grow your business.',
    
    // Advantages section
    'Why Choose My Services': 'Why Choose My Services',
    'Personalized Approach': 'Personalized Approach',
    'I take the time to understand your unique business needs and objectives, ensuring all deliverables are perfectly aligned with your vision and goals.': 'I take the time to understand your unique business needs and objectives, ensuring all deliverables are perfectly aligned with your vision and goals.',
    'Quality Equipment': 'Quality Equipment',
    'Using state-of-the-art cameras, lighting, and editing software to ensure the highest quality results for your projects.': 'Using state-of-the-art cameras, lighting, and editing software to ensure the highest quality results for your projects.',
    'Fast Turnaround': 'Fast Turnaround',
    'Efficient project management and workflow processes mean you get your content when you need it without sacrificing quality.': 'Efficient project management and workflow processes mean you get your content when you need it without sacrificing quality.',
    'Affordable Packages': 'Affordable Packages',
    'Competitive pricing structures designed to fit businesses of all sizes, from startups to established enterprises.': 'Competitive pricing structures designed to fit businesses of all sizes, from startups to established enterprises.',
    
    // About section
    'I\'m a passionate videographer with over 20 years of experience capturing life\'s most precious moments. My journey began with a simple camera, which quickly evolved into a deep love for visual storytelling.': 'I\'m a passionate videographer with over 20 years of experience capturing life\'s most precious moments. My journey began with a simple camera, which quickly evolved into a deep love for visual storytelling.',
	'My name is Matthias Meyfarth.': 'My name is Matthias Meyfarth.',
    'Whether I\'m filming weddings, documenting travel adventures, or shooting editorial content, I bring a unique perspective and artistic vision to every project.': 'Whether I\'m filming weddings, documenting travel adventures, or shooting editorial content, I bring a unique perspective and artistic vision to every project.',
    'I\'ve had the privilege of collaborating with amazing clients around the world.': 'I\'ve had the privilege of collaborating with amazing clients around the world.',
	'Crafting Visual Stories with Passion and Precision': 'Crafting Visual Stories with Passion and Precision',
    
    // Stats
    'Videos Produced': 'Videos Produced',
    'Photos Taken': 'Photos Taken',
    'Websites Built': 'Websites Built',
    'Happy Clients': 'Happy Clients',
    
    // Contact page
    'Get in Touch': 'Get in Touch',
    'Contact Information': 'Contact Information',
    'Send us a Message': 'Send us a Message',
    'Full Name': 'Full Name',
    'Email Address': 'Email Address',
    'Phone Number': 'Phone Number',
    'Your Message': 'Your Message',
    'Submit': 'Submit',
    'Please fill out all required fields': 'Please fill out all required fields',
    'Thank you for your message!': 'Thank you for your message!',
    'Address': 'Address',
    'Phone': 'Phone',
    'Email': 'Email',
    
    // Website Modal
    'Visit Website': 'Visit Website'
  },
  de: {
    // Navigation
    'Home': 'Startseite',
    'Portfolio': 'Portfolio',
    'Services': 'Dienstleistungen',
    'Advantages': 'Vorteile',
    'About': 'Über mich',
    'Contact': 'Kontakt',
	  'Clients': 'Kunden',
    
    // Portfolio tabs
    'Videos': 'Videos',
    'Photos': 'Fotos',
    'Websites': 'Webseiten',
	
	 // Portfolio title
    'Professional video production services for corporate, promotional, and creative projects' : 'Professionelle Video Produktionen für Unternehmen, Events und kreative Projekte',
	'High-quality photography capturing moments, landscapes, and commercial subjects with creativity' : 'Professionelle Fotografie, die besondere Momente, beeindruckende Landschaften und kommerzielle Inhalte kreativ festhält',
	'Custom website design and development for businesses of all sizes and industries' : 'Maßgeschneidertes Webdesign und Webentwicklung für Unternehmen aller Größen und Branchen',
	
    // Section titles
    'Visual Stories': 'Visuelle Geschichten',
    'Capturing life\'s most beautiful moments through professional videography': 'Die schönsten Momente des Lebens durch professionelle Videografie festhalten',
    'Explore My Work': 'Entdecke meine Arbeit',
    'About Me': 'Über mich',
    
    // Hero Slider
    'Stunning Photography': 'Beeindruckende Fotografie',
    'Professional photography that captures the essence of your brand': 'Professionelle Fotografie, die das Wesen Ihrer Marke einfängt',
    'Modern Websites': 'Moderne Webseiten',
    'Responsive websites that work perfectly on all devices': 'Responsive Webseiten, die auf allen Geräten perfekt funktionieren',
	
	//Clients section
	'Trusted by innovative companies around the world': 'Vertrauen von innovativen Kunden aus aller Welt',
	
    
    // Services section
    'How I Can Help Your Business Grow': 'Wie ich Ihrem Unternehmen zum Wachstum verhelfen kann',
    'Professional Video Production': 'Professionelle Videoproduktion',
    'Videos can increase engagement by up to 80% on your website and social media platforms. With professional videography, your business can showcase products, services, and brand values in a compelling format that connects emotionally with your audience.': 'Videos können die Interaktion auf Ihrer Website und Ihren Social-Media-Plattformen um bis zu 80% steigern. Mit professioneller Videografie kann Ihr Unternehmen Produkte, Dienstleistungen und Markenwerte in einem überzeugenden Format präsentieren, das emotional mit Ihrem Publikum in Verbindung steht.',
    'High-Quality Photography': 'Hochwertige Fotografie',
    'Professional photography can elevate your brand image and make you stand out from competitors. High-quality visuals are essential for marketing materials, websites, and social media, helping you communicate your brand message effectively and attract more customers.': 'Professionelle Fotografie kann Ihr Markenimage verbessern und Sie von Mitbewerbern abheben. Hochwertige Visuals sind unverzichtbar für Marketingmaterialien, Websites und soziale Medien und helfen Ihnen, Ihre Markenbotschaft effektiv zu kommunizieren und mehr Kunden anzuziehen.',
    'Custom Website Development': 'Individuelle Website-Entwicklung',
    'A well-designed website serves as your 24/7 digital storefront. By creating responsive, user-friendly websites tailored to your business needs, I help you establish a professional online presence that converts visitors into customers and provides valuable analytics to grow your business.': 'Eine gut gestaltete Website dient als Ihr digitales Schaufenster rund um die Uhr. Durch die Erstellung responsiver, benutzerfreundlicher Websites, die auf Ihre Geschäftsanforderungen zugeschnitten sind, helfe ich Ihnen, eine professionelle Online-Präsenz aufzubauen, die Besucher in Kunden umwandelt und wertvolle Analysen zur Förderung Ihres Unternehmens liefert.',
    
    // Advantages section
    'Why Choose My Services': 'Warum Sie meine Dienste wählen sollten',
    'Personalized Approach': 'Persönlicher Ansatz',
    'I take the time to understand your unique business needs and objectives, ensuring all deliverables are perfectly aligned with your vision and goals.': 'Ich nehme mir die Zeit, Ihre einzigartigen Geschäftsanforderungen und Ziele zu verstehen, um sicherzustellen, dass alle Lieferumfänge perfekt auf Ihre Vision und Ziele abgestimmt sind.',
    'Quality Equipment': 'Qualitätsausrüstung',
    'Using state-of-the-art cameras, lighting, and editing software to ensure the highest quality results for your projects.': 'Verwendung modernster Kameras, Beleuchtung und Bearbeitungssoftware, um höchste Qualitätsergebnisse für Ihre Projekte zu gewährleisten.',
    'Fast Turnaround': 'Schnelle Bearbeitung',
    'Efficient project management and workflow processes mean you get your content when you need it without sacrificing quality.': 'Effiziente Projektmanagement- und Arbeitsabläufe bedeuten, dass Sie Ihre Inhalte erhalten, wenn Sie sie benötigen, ohne auf Qualität zu verzichten.',
    'Affordable Packages': 'Erschwingliche Pakete',
    'Competitive pricing structures designed to fit businesses of all sizes, from startups to established enterprises.': 'Wettbewerbsfähige Preisstrukturen, die für Unternehmen aller Größen, von Startups bis hin zu etablierten Unternehmen, geeignet sind.',
    
    // About section
	'Crafting Visual Stories with Passion and Precision': 'Kreation visueller Geschichten mit Passion und Präzision',
	'My name is Matthias Meyfarth.': 'Ich heiße Matthias Meyfarth.',
    'I\'m a passionate videographer with over 20 years of experience capturing life\'s most precious moments. My journey began with a simple camera, which quickly evolved into a deep love for visual storytelling.': 'Ich bin ein leidenschaftlicher Videograf mit über 20 Jahren Erfahrung im Festhalten der wertvollsten Momente des Lebens. Meine Reise begann mit einer einfachen Kamera, die sich schnell zu einer tiefen Liebe zum visuellen Geschichtenerzählen entwickelte.',
    'Whether I\'m filming weddings, documenting travel adventures, or shooting editorial content, I bring a unique perspective and artistic vision to every project.': 'Ob ich Hochzeiten filme, Reiseabenteuer dokumentiere oder redaktionelle Inhalte drehe, ich bringe eine einzigartige Perspektive und künstlerische Vision in jedes Projekt ein.',
    'I\'ve had the privilege of collaborating with amazing clients around the world.': 'Ich hatte das Privileg, mit erstaunlichen Kunden auf der ganzen Welt zusammenzuarbeiten.',
    
    // Stats
    'Videos Produced': 'Produzierte Videos',
    'Photos Taken': 'Aufgenommene Fotos',
    'Websites Built': 'Erstellte Webseiten',
    'Happy Clients': 'Zufriedene Kunden',
    
    // Contact page
    'Get in Touch': 'Kontaktieren Sie uns',
    'Contact Information': 'Kontaktinformationen',
    'Send us a Message': 'Senden Sie uns eine Nachricht',
    'Full Name': 'Vollständiger Name',
    'Email Address': 'E-Mail-Adresse',
    'Phone Number': 'Telefonnummer',
    'Your Message': 'Ihre Nachricht',
    'Submit': 'Absenden',
    'Please fill out all required fields': 'Bitte füllen Sie alle Pflichtfelder aus',
    'Thank you for your message!': 'Vielen Dank für Ihre Nachricht!',
    'Address': 'Adresse',
    'Phone': 'Telefon',
    'Email': 'E-Mail',
    
    // Website Modal
    'Visit Website': 'Website besuchen',

    //Footer
    'Imprint': 'Impressum',
    'Privacy Policy': 'Datenschutzerklärung',
    'Terms of Service': 'Geschäftsbedingungen'
  }
};

// Create context
type LanguageContextType = {
  language: string;
  toggleLanguage: () => void;
  t: (key: string) => string;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Provider component
export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Change default language to German
  const [language, setLanguage] = useState('de');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'de' : 'en');
  };

const t = (key: string): string => {
  const translation = translations[language][key];
  if (!translation) {
    console.warn(`Missing translation for key: ${key}`);
  }
  return translation || key;
};

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook to use the language context
export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
